import React, { useEffect, useState } from 'react';
import Header from '../../../components/Header';
import FooterTwo from '../../../components/Footer/index';
import StudyBreadcrumb from '../../../components/Breadcrumb/outreach';
import ScrollToTop from '../../../components/ScrollTop';
// import SideManu from './sidebar';
import Curriculumimage from './images/curriculum.png';

const backendUrl = process.env.REACT_APP_DATABASEURL;

const Phdsyllabus = () => {
    const [activeIndex, setActiveIndex] = useState(0);
    const [syllabusData, setSyllabusData] = useState([]);
    const [loading, setLoading] = useState(true);

    const toggleAccordion = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    useEffect(() => {
        fetch(`${backendUrl}api/fetch_curriculum_pg`)
            .then((response) => response.json())
            .then((data) => {
                setSyllabusData(data.curriculum_pg_data); // Adjusted to match your JSON structure
                setLoading(false);
            })
            .catch((error) => {
                console.error('Error fetching syllabus:', error);
                setLoading(false);
            });
    }, []);

    return (
        <>
            <Header parentMenu='offered' menuCategoryEnable='enable' />

            <div className="react-wrapper background_height">
                <div className="react-wrapper-inner background_image">
                    <StudyBreadcrumb pageTitle="PG Program Curriculum" />
                    <div className="high_quality-section pt---60 pb---120">
                        <div className="container">
                            {/* <SideManu /> */}
                            <div className="row m-0 react__title__section-all">
                                <div className="col-md-12 col-sm-12 col-12 bg_color" style={{ backgroundColor: "#fff" }}>
                                    <br />
                                    <div className="container">
                                        {loading ? (
                                            <p>Loading syllabus...</p>
                                        ) : syllabusData.length === 0 ? (
                                            <p>No Ph.D syllabus data found.</p>
                                        ) : (() => {
                                            // 1. Identify all unique regulations and sort them intelligently
                                            const regulations = [...new Set(syllabusData.map(item => item.regulation))].sort((a, b) => {
                                                const getScore = (s) => {
                                                    const match = s.match(/AR(\d+)/);
                                                    if (match) {
                                                        const baseYear = parseInt(match[1]);
                                                        // If it's a range like AR24-26, give it a slightly higher score than the base year
                                                        return s.includes('-') ? baseYear + 0.5 : baseYear;
                                                    }
                                                    return 999;
                                                };
                                                return getScore(a) - getScore(b);
                                            });
                                            
                                            // 2. Identify all unique program (subject) names across all regulations
                                            const programMap = new Map();
                                            
                                            syllabusData.forEach(regDoc => {
                                                regDoc.papers.forEach(paper => {
                                                    if (!programMap.has(paper.subject_name)) {
                                                        programMap.set(paper.subject_name, {});
                                                    }
                                                    programMap.get(paper.subject_name)[regDoc.regulation] = paper.attachment;
                                                });
                                            });

                                            const programs = Array.from(programMap.keys());

                                            return (
                                                <div>
                                                    <button
                                                        className={`accordion active-card`}
                                                        onClick={() => toggleAccordion(0)}
                                                    >
                                                        <img src={Curriculumimage} alt="curriculum" style={{ height: '40px' }} />
                                                        &nbsp;&nbsp;&nbsp;&nbsp;Ph.D Course Work Syllabus
                                                        <span className="symbol">{activeIndex === 0 ? '▲' : '▼'}</span>
                                                    </button>
                                                    <div style={{ display: activeIndex === 0 ? 'block' : 'none' }}>
                                                        <br />
                                                        <table style={{ width: "100%" }}>
                                                            <thead>
                                                                <tr>
                                                                    <th style={{ textAlign: 'center' }}>Program</th>
                                                                    {regulations.map(reg => (
                                                                        <th key={reg} style={{ textAlign: 'center' }}>{reg}</th>
                                                                    ))}
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {programs.map((program, i) => (
                                                                    <tr key={i}>
                                                                        <td>{program}</td>
                                                                        {regulations.map(reg => (
                                                                            <td key={reg} style={{ textAlign: "center" }}>
                                                                                {programMap.get(program)[reg] ? (
                                                                                    <a
                                                                                        href={`${backendUrl}/${programMap.get(program)[reg]}`}
                                                                                        target="_blank"
                                                                                        rel="noopener noreferrer"
                                                                                        style={{ color: "#000", textAlign: "center" }}
                                                                                        className="namehover"
                                                                                    >
                                                                                        View
                                                                                    </a>
                                                                                ) : (
                                                                                    "-"
                                                                                )}
                                                                            </td>
                                                                        ))}
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                        <br />
                                                    </div>
                                                </div>
                                            );
                                        })()}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ScrollToTop />
                </div>
            </div>

            <FooterTwo />
        </>
    );
};

export default Phdsyllabus;
